import React from 'react';

export const AlertBadge = ({ iconColor }) => {
    return (
        <div className="clx-step__badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <circle
                    stroke={iconColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    cx="10"
                    cy="10"
                    r="9"
                />
                <line
                    stroke={iconColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    x1="10"
                    y1="6"
                    x2="10"
                    y2="10"
                />
                <line
                    stroke={iconColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    x1="10"
                    y1="14"
                    x2="10"
                    y2="14"
                />
            </svg>
        </div>
    );
};

export const CallBadge = ({ iconColor }) => {
    return (
        <div className="clx-step__badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
                <path
                    d="M.54,14.06a14.3,14.3,0,0,1,18.92,0,1.68,1.68,0,0,1,.05,2.42l-1,1a1.69,1.69,0,0,1-2.24.12L14.57,16.3A1.66,1.66,0,0,1,13.93,15v-2.2A12.67,12.67,0,0,0,6.09,13v2a1.71,1.71,0,0,1-.64,1.33L3.76,17.63a1.68,1.68,0,0,1-2.23-.12l-1-1A1.67,1.67,0,0,1,.54,14.06ZM10,5h0A1,1,0,0,1,9,4V1a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1V4A1,1,0,0,1,10,5Zm4.17,1.83h0a1,1,0,0,1,0-1.42l2.12-2.12a1,1,0,0,1,1.42,0h0a1,1,0,0,1,0,1.42L15.59,6.83A1,1,0,0,1,14.17,6.83Zm-8.34,0h0a1,1,0,0,1-1.42,0L2.29,4.71a1,1,0,0,1,0-1.42h0a1,1,0,0,1,1.42,0L5.83,5.41A1,1,0,0,1,5.83,6.83Z"
                    fill={iconColor}
                />
            </svg>
        </div>
    );
};

export const IconBadge = ({ icon }) => {
    return <div className="clx-step__badge">{icon}</div>;
};

export const IncomeBadge = ({ iconColor }) => {
    return (
        <div className="clx-step__badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path
                    d="M9.9,9.48a2.81,2.81,0,0,1,.75-1.7A2.72,2.72,0,0,1,12.31,7h1a.21.21,0,0,0,.21-.21,6.74,6.74,0,1,0-3.69,6,.2.2,0,0,0,.08-.08.2.2,0,0,0,0-.11ZM5.38,9.9a.62.62,0,0,1-.44-.18.64.64,0,0,1,.44-1.08H7.09a.52.52,0,0,0,.32-.11.48.48,0,0,0,.17-.29.54.54,0,0,0,0-.33.56.56,0,0,0-.25-.23L5.54,7a1.72,1.72,0,0,1-.84-.71A1.75,1.75,0,0,1,5.85,3.64.29.29,0,0,0,6,3.57a.23.23,0,0,0,0-.14V3.17a.64.64,0,0,1,1.27,0v.22a.2.2,0,0,0,.06.14.21.21,0,0,0,.15.07h.42a.62.62,0,0,1,.44.18.64.64,0,0,1-.44,1.08H6.2a.49.49,0,0,0-.49.4.54.54,0,0,0,0,.33A.56.56,0,0,0,6,5.82l1.74.69a1.72,1.72,0,0,1,.84.71A1.75,1.75,0,0,1,7.44,9.86a.29.29,0,0,0-.12.07.23.23,0,0,0,0,.14v.26a.64.64,0,0,1-1.27,0v-.21A.2.2,0,0,0,6,10,.21.21,0,0,0,5.8,9.9Z"
                    fill={iconColor}
                />
                <path
                    d="M18.85,8.22H12.31c-.55,0-1.14.82-1.14,1.26v9.26c0,.44.59,1.26,1.14,1.26h6.54c.56,0,1.15-.82,1.15-1.26V9.48C20,9,19.41,8.22,18.85,8.22Zm-1.16,9.69a.61.61,0,0,1-.35-.11.65.65,0,0,1-.24-.28.67.67,0,0,1,0-.37.64.64,0,0,1,.86-.46.7.7,0,0,1,.28.23.66.66,0,0,1,.11.35.7.7,0,0,1-.05.25.7.7,0,0,1-.34.34A.69.69,0,0,1,17.69,17.91Zm-4.84-.64a.66.66,0,0,1,.11-.35.63.63,0,0,1,.28-.23.56.56,0,0,1,.36,0,.59.59,0,0,1,.33.17.76.76,0,0,1,.17.32.68.68,0,0,1,0,.37.62.62,0,0,1-.23.28.61.61,0,0,1-.35.11.64.64,0,0,1-.45-.19A.67.67,0,0,1,12.85,17.27Zm0-2.11a.66.66,0,0,1,.11-.35.64.64,0,0,1,.64-.27.67.67,0,0,1,.33.18.71.71,0,0,1,.17.32.63.63,0,0,1,0,.36.6.6,0,0,1-.58.39.63.63,0,0,1-.45-.18A.67.67,0,0,1,12.85,15.16ZM15,17.27a.66.66,0,0,1,.11-.35.7.7,0,0,1,.28-.23.63.63,0,0,1,.86.46.67.67,0,0,1,0,.37.65.65,0,0,1-.24.28.61.61,0,0,1-.35.11.65.65,0,0,1-.63-.64Zm0-2.11a.66.66,0,0,1,.11-.35.7.7,0,0,1,.28-.23.67.67,0,0,1,.37,0,.68.68,0,0,1,.32.18.56.56,0,0,1,.17.32.63.63,0,0,1,0,.36.62.62,0,0,1-.24.29.6.6,0,0,1-.35.1.62.62,0,0,1-.44-.18A.64.64,0,0,1,15,15.16Zm2.74.63a.6.6,0,0,1-.35-.1.62.62,0,0,1-.24-.29.63.63,0,0,1,0-.36.56.56,0,0,1,.17-.32.68.68,0,0,1,.32-.18.67.67,0,0,1,.37,0,.7.7,0,0,1,.28.23.66.66,0,0,1,.11.35.64.64,0,0,1-.19.45A.62.62,0,0,1,17.69,15.79Zm.21-2.94H13.27c-.23,0-.45-.18-.45-.58V10.33c0-.4.23-.57.45-.57H17.9c.22,0,.45.17.45.57v2C18.35,12.69,18.12,12.85,17.9,12.85Z"
                    fill={iconColor}
                />
            </svg>
        </div>
    );
};

export const TextBadge = ({ iconColor }) => {
    return (
        <div className="clx-step__badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path
                    d="M9.1,3A1.91,1.91,0,0,1,11,4.88V18.1A1.91,1.91,0,0,1,9.1,20H1.9A1.9,1.9,0,0,1,0,18.11V4.88A1.91,1.91,0,0,1,1.9,3ZM9,17V6H2V17ZM19,0H14a1,1,0,0,0-1,1V8l2.86-2H19a1,1,0,0,0,1-1V1A1,1,0,0,0,19,0Z"
                    fill={iconColor}
                />
            </svg>
        </div>
    );
};

export const ConfirmationBadge = ({ iconColor }) => {
    return (
        <div className="clx-step__badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <polyline
                    stroke={iconColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    points="16.5 4 10 16.5 4 10"
                />
            </svg>
        </div>
    );
};

export const LoadingBadge = ({ iconColor }) => {
    return (
        <div className="clx-step__badge">
            <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="64px"
                height="64px"
                viewBox="0 0 40 40"
                enableBackground="new 0 0 40 40"
            >
                <path
                    opacity="0.2"
                    fill={iconColor}
                    d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                />
                <path
                    fill={iconColor}
                    d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    C22.32,8.481,24.301,9.057,26.013,10.047z"
                >
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 20 20"
                        to="360 20 20"
                        dur="0.75s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        </div>
    );
};
